import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from '../../services/routing';
import { useHeaderItemClassName } from './useHeaderItemClassName';
import { BaseHeader } from './BaseHeader';
import { HeaderNav } from './HeaderNav';
import { HeaderItem } from './useHeaderItems';

type Props = {
  visibleItems: HeaderItem[];
};

export const AppHeader: FunctionComponent<Props> = ({ visibleItems = [] }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { headerItemClassName } = useHeaderItemClassName();

  const items = [
    {
      key: 'newQuote' as HeaderItem,
      label: t('app:header:newQuote'),
      onClick: () => navigate.newQuote(),
    },
    {
      key: 'activityTracking' as HeaderItem,
      label: t('app:header:activityTracking'),
      onClick: () => navigate.dashboardQuotes(),
    },
    {
      key: 'search' as HeaderItem,
      label: t('app:header:search'),
      onClick: () => navigate.search(),
    },
    {
      key: 'notes' as HeaderItem,
      label: t('app:header:notes'),
      onClick: () => navigate.conversations(),
    },
  ].filter((item) => visibleItems.includes(item.key));

  return <BaseHeader navigation={<HeaderNav visibleItems={items} className={headerItemClassName} />} />;
};
